import DOMPurify from 'src/_helpers/dompurify'
import { getPreferredTranslation } from 'src/_helpers/getPreferredTranslation'
import Typography from 'src/components/design-system/Typography'
import { getPageTextWidthClass } from 'src/_helpers/pageTemplate'

export default function TextContent({ block, locale, variant = '', template = 'default' }) {
  const translation = getPreferredTranslation(block, locale) || {}
  const title = translation?.title?.trim()
  const text = translation?.text
  const textFormatted = text ? DOMPurify.sanitize(text, { allowImages: true }) : null

  if (!title && !textFormatted) {
    return null
  }

  return (
    <div
      className={`flex flex-col ${variant === 'journal' || variant === 'article' ? 'gap-23' : 'gap-16'} ${variant === 'article' ? 'd:max-w-[777px]' : getPageTextWidthClass(template)}`}
    >
      {title && (
        <Typography
          variant="h2"
          color={`${variant === 'journal' || variant === 'article' ? 'text-basic-black' : 'text-dark-blue-dark-blue1'}`}
        >
          {title}
        </Typography>
      )}
      {textFormatted && (
        <Typography
          variant={variant === 'journal' || variant === 'article' ? 'body2' : 'subtitle2'}
          color={`${variant === 'journal' || variant === 'article' ? 'text-basic-black' : 'text-dark-blue-dark-blue1'}`}
          component="div"
          className="text-block-content"
          dangerouslySetInnerHTML={{ __html: textFormatted }}
        />
      )}
    </div>
  )
}
